import { Injectable } from '@angular/core';
import {configURI, configURI2} from '../../../shared/apiUrlConfig';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AgentDashboardService {
  url = environment.configURI;
  load;
  private vendorDashboardDetails = "/vendor/";
  private clientVendorDashboardDetails = "/client/vendor/";
  private category = "/dashboard";

  constructor(public httpClient: HttpClient,
              public userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  getAgentDetails(agentId) {
    let role = parseInt(localStorage.getItem("RoleVal"))
        if (role === 8) {
          return this.httpClient.get(`${this.url}${this.clientVendorDashboardDetails}${agentId}${this.category}`).catch(this.userFriendlyMsgs.errorHandler);
        } else {
          return this.httpClient.get(`${this.url}${this.vendorDashboardDetails}${agentId}${this.category}`).catch(this.userFriendlyMsgs.errorHandler);
          
        }

  }
}



// WEBPACK FOOTER //
// ./src/app/services/agent_dashboard/agent-dashboard.service.ts